import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import ButtonGetStarted from 'components/newMagic/ButtonGetStarted'
import { bigButtonStyle, buttonGreenStyle } from '../styled'

const Wrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  ${mediaQuery.tabletMin} {
    gap: 16px;
  }
  ${mediaQuery.desktopMin} {
    gap: 23px;
  }
  ${mediaQuery.mobile} {
    & > a {
      padding: 10px 17px;
      line-height: 17px;
    }
  }
`

const OutlineButton = styled.a`
  text-decoration: none;
  ${buttonGreenStyle};
  ${bigButtonStyle};
`

const NavButtons = ({ translations }) => (
  <Wrapper>
    <ButtonGetStarted
      color="offWhiteDark"
      buttonLabel={translations.getStartedButtonLabel}
      isLarge
    />
    <OutlineButton href={process.env.MAGIC_URL}>
      {translations.loginInButtonLabel}
    </OutlineButton>
  </Wrapper>
)

export default NavButtons
